var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"global-scan"}},[(!_vm.bar_code)?_c('v-quagga',{attrs:{"multiple":false,"torch":false,"onDetected":_vm.getBarcode,"inputStream":{
      constraints: {
        /* width: 1280,
        height: 480 */
      },
    },"singleChannel":false,"readerSize":_vm.readerSize,"readerTypes":[
      'ean_reader',
      'ean_8_reader',
      'upc_reader',
      'upc_e_reader'
    ]}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }